export default __webpack_public_path__ + "static/media/add_3(1).6aaddff6.png";